<template>
	<div class="h-100 flex-row">
		<sf-button line :onClick="searchSqlId">{{ getMessage_('SWCC000754') }}</sf-button>
		<sf-button line :onClick="addSql">{{ getMessage_('SWCC000755') }}</sf-button>
		<sf-button icon="file" line :onClick="exportXml">export </sf-button>
		<div
			class="uploadRow"
			:style="{
				display: 'inline-flex'
			}"
		>
			<el-upload
				action=""
				:file-list="fileList"
				:on-change="FileUploadChange"
				accept=".xml"
				:auto-upload="false"
				:on-remove="handleUploadRemove"
				:limit="1"
			>
				<sf-button icon="file" line>import </sf-button>
				<!-- <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div> -->
			</el-upload>
		</div>
		<sf-card class="border-0 bg-transparent" style="height: 93%; padding-top: 10px">
			<sf-data-table
				ref="searchTable"
				:columns="columns"
				:rows="rows"
				rowSize="sm"
				:showHeader="false"
				@row-click="onClick"
				paging
				:pageUnit="pageUnit_"
				:pageArray="screen.pageArray"
				:totalSize="totalSize_"
				@changedPage="changedPage"
			>
			</sf-data-table>
		</sf-card>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/SQLEditor/store/helpers';
import { utils } from '@sfaas/util';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			fileList: [],
			screen: {}
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					label: 'sql',
					prop: 'sqlId'
				}
			];
		},
		rows() {
			return this.sqlIds;
			// return this.filterSqlId();
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...utils,
		changedPage({ currentPageVal, pageUnitVal }) {
			Promise.resolve()
				.then(() =>
					this.DEFAULT_ASSIGN({ key: 'pagingInfo', value: { ...this.pagingInfo, currentPage: currentPageVal, pageUnit: pageUnitVal } })
				)
				.then(this.searchSqlId);
		},
		handleUploadRemove(oneFile, fileList) {
			//oneFile: 변경된 파일  fileList: 전체 파일리스트
			//this.fileList = fileList;
			this.fileList = [];
		},
		FileUploadChange(oneFile) {
			let reader = new FileReader();
			reader.readAsText(oneFile.raw);
			reader.onload = e => {
				//Read file contents
				const cont = e.target.result;
				var buffer = this.StringtoBuffer(e.target.result);
				const xmlText = this.arrayBufferToBase64(buffer);
				this.importXml_({ xmlText: xmlText })
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			};
		},
		searchSqlId() {
			this.$sf_toggleLoading(true);
			this.getSqlIds_({ urlSearchParams: this.urlSearchParams_ })
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		addSql() {
			const newSql = {
				sqlId: 'New Sql Id',
				sqlParameters: [],
				sqlText:
					' <sql id="NewSQLID"><!-- Writer        :  \n    Write Date    : 2010-02-08. \n    Description    : Getting the Station Code Information by Station Code. \n    History    : None. --><![CDATA[	]]></sql> '
			};

			this.sqlContent.push(newSql);
		},
		async exportXml() {
			this.$sf_toggleLoading(true);
			await this.exportXml_()
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
			var bytearray = this.base64ToArrayBuffer(this.xmlData);
			var xmltext = this.binToString(bytearray);

			const element = document.createElement('a');
			var bb = new Blob([xmltext], { type: 'application/xml' });
			element.setAttribute('href', window.URL.createObjectURL(bb));
			element.setAttribute('download', 'SQLMAP');

			element.dataset.downloadurl = ['text/plain', element.download, element.href].join(':');
			element.draggable = true;
			element.classList.add('dragout');

			element.click();
		},
		arrayBufferToBase64(buffer) {
			var binary = '';
			var bytes = new Uint8Array(buffer);
			var len = bytes.byteLength;
			for (var i = 0; i < len; i++) {
				binary += String.fromCharCode(bytes[i]);
			}
			return window.btoa(binary);
		},
		StringtoBuffer(str) {
			let utf8Encode = new TextEncoder();
			return utf8Encode.encode(str);
		},
		base64ToArrayBuffer(base64) {
			var binary_string = window.atob(base64);
			var len = binary_string.length;
			var bytes = new Uint8Array(len);
			for (var i = 0; i < len; i++) {
				bytes[i] = binary_string.charCodeAt(i);
			}
			return bytes.buffer;
		},
		binToString(buf) {
			// return String.fromCharCode.apply(null, new Uint16Array(buf));
			var decoder = new TextDecoder('utf-8');
			return decoder.decode(new Uint8Array(buf));
		},
		onClick(row) {
			this.DEFAULT_ASSIGN({
				key: 'searchParams',
				value: row
			});
			this.$sf_toggleLoading(true);
			this.getSqlContent_(this.searchParams.sqlId)
				// .then(this.getSqlLog_(this.searchParams.sqlId))
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
		// filterSqlId() {
		// 	let sqlList = this.sqlIds.sort(function (a, b) {
		// 		return a.sqlId < b.sqlId ? -1 : a.sqlId > b.sqlId ? 1 : 0;
		// 	});
		// 	return sqlList;
		// }
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);

		this.searchSqlId();
	}
};
</script>

<style lang="scss">
.uploadRow {
	padding-left: 10px;
}
</style>
